import { createTheme } from '@mui/material/styles';
import { tbTheme } from './config';

// const primary = { main: '#3D8BF8' };
const secondary = { main: '#ffffff', contrast: '#526ee7' };
// const primaryLight = '#e2e8ff';
const darkShade1 = '#2d3a48';
const success = '#47be8a';
const error = '#E56B6B';
const warning = '#f6a609';

const theme = createTheme({
    palette: {
        primary: {
            main: tbTheme.primary
        },
        secondary: {
            main: tbTheme.secondary,
            contrastText: secondary.contrast
        },
        success: {
            main: success
        },
        error: {
            main: error
        },
        warning: {
            main: warning
        },
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        allVariants: {
            color: darkShade1
        },
        button: {
            fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: 1.75,
            letterSpacing: '0.2px',
            textTransform: 'capitalize'
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
                disableElevation: true,
                color: 'primary',
                disableRipple: true
            }
        }
    },
    header: tbTheme.header
});

export default theme;
